var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"home-links"},[_c('a',{attrs:{"href":"https://github.com/MYSTACK555","target":"_blank","rel":"noopener"}},[_vm._v(" GitHub ")]),_c('a',{attrs:{"href":"https://www.growthbunker.dev/vuetimeline/?ref=madewithvuejs.com","target":"_blank","rel":"noopener"}},[_vm._v(" Vue Timeline ")])])
}]

export { render, staticRenderFns }